// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channels-container {
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.channels-header {
  margin-bottom: 2rem;
}

.channels-header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.channels-header p {
  color: #b0b3c1;
  font-size: 1.1rem;
}

.add-channel-form {
  background: rgba(26, 26, 46, 0.6);
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid rgba(88, 101, 242, 0.2);
  margin-bottom: 2rem;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.input-icon {
  color: #b0b3c1;
  font-size: 1.5rem;
}

.form-row input {
  flex: 1 1;
  background: rgba(15, 15, 30, 0.5);
  border: 1px solid rgba(88, 101, 242, 0.2);
  color: #ffffff;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
}

.form-row input:focus {
  border-color: #5865F2;
}

.form-row button {
  background-color: #5865F2;
  color: #ffffff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.form-row button:hover:not(:disabled) {
  background-color: #4752C4;
  transform: translateY(-2px);
}

.form-row button:disabled {
  background-color: rgba(88, 101, 242, 0.3);
  cursor: not-allowed;
}

.form-hint {
  color: #b0b3c1;
  font-size: 0.9rem;
  margin: 0;
}

.channels-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.channel-card {
  background: rgba(26, 26, 46, 0.6);
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid rgba(88, 101, 242, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.channel-card:hover {
  border-color: rgba(88, 101, 242, 0.5);
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.channel-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.channel-icon {
  font-size: 2rem;
  color: #5865F2;
}

.channel-details h3 {
  font-size: 1.2rem;
  margin: 0 0 0.25rem 0;
  font-family: 'Courier New', monospace;
  color: #ffffff;
}

.channel-details p {
  color: #b0b3c1;
  font-size: 0.9rem;
  margin: 0;
}

.remove-btn {
  background-color: #ef4444;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.remove-btn:hover {
  background-color: #dc2626;
  transform: scale(1.05);
}

.no-channels {
  background: rgba(26, 26, 46, 0.6);
  border-radius: 16px;
  padding: 4rem 2rem;
  border: 1px solid rgba(88, 101, 242, 0.2);
  text-align: center;
}

.no-channels svg {
  color: #5865F2;
  opacity: 0.5;
  margin-bottom: 1rem;
}

.no-channels h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.no-channels p {
  color: #b0b3c1;
  margin: 0.5rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Channels.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,yCAAyC;EACzC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".channels-container {\n  padding: 2rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.channels-header {\n  margin-bottom: 2rem;\n}\n\n.channels-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.channels-header p {\n  color: #b0b3c1;\n  font-size: 1.1rem;\n}\n\n.add-channel-form {\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 16px;\n  padding: 2rem;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n  margin-bottom: 2rem;\n}\n\n.form-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.input-icon {\n  color: #b0b3c1;\n  font-size: 1.5rem;\n}\n\n.form-row input {\n  flex: 1;\n  background: rgba(15, 15, 30, 0.5);\n  border: 1px solid rgba(88, 101, 242, 0.2);\n  color: #ffffff;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  outline: none;\n}\n\n.form-row input:focus {\n  border-color: #5865F2;\n}\n\n.form-row button {\n  background-color: #5865F2;\n  color: #ffffff;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.form-row button:hover:not(:disabled) {\n  background-color: #4752C4;\n  transform: translateY(-2px);\n}\n\n.form-row button:disabled {\n  background-color: rgba(88, 101, 242, 0.3);\n  cursor: not-allowed;\n}\n\n.form-hint {\n  color: #b0b3c1;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.channels-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.channel-card {\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.channel-card:hover {\n  border-color: rgba(88, 101, 242, 0.5);\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.channel-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.channel-icon {\n  font-size: 2rem;\n  color: #5865F2;\n}\n\n.channel-details h3 {\n  font-size: 1.2rem;\n  margin: 0 0 0.25rem 0;\n  font-family: 'Courier New', monospace;\n  color: #ffffff;\n}\n\n.channel-details p {\n  color: #b0b3c1;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.remove-btn {\n  background-color: #ef4444;\n  color: #ffffff;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.remove-btn:hover {\n  background-color: #dc2626;\n  transform: scale(1.05);\n}\n\n.no-channels {\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 16px;\n  padding: 4rem 2rem;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n  text-align: center;\n}\n\n.no-channels svg {\n  color: #5865F2;\n  opacity: 0.5;\n  margin-bottom: 1rem;\n}\n\n.no-channels h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.no-channels p {\n  color: #b0b3c1;\n  margin: 0.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
